const openFlows = (callback: () => void): void => {
  const openFlowsEvent = new CustomEvent('openFlows', { detail: { callback } });
  window.dispatchEvent(openFlowsEvent);
};

export { openFlows };
